import { useTranslation } from "react-i18next";

import { SettingsSectionWrapper } from "~/components/settings/SettingsSection";

import { CubingFillRates } from "./CubingFillRates";

export function CubingSection() {
  const { t } = useTranslation();

  return (
    <SettingsSectionWrapper title={t("cubing")}>
      <CubingFillRates />
    </SettingsSectionWrapper>
  );
}
